import React, {useContext} from "react";
import HeaderPage from "../components/HeaderPage";
import AppConfigContext from "../../../contexts/AppConfigContext";
import Game from "../../../rest/jtmc/models/Game";
import GameFrame from "../../../components/custom-components/GameFrame";

export default function GameScreen({route, navigation}: any) {
    const configContext = useContext(AppConfigContext);

    let {game}: { game: Game } = route.params;

    return <HeaderPage title={"بازی"} scrollableContent={false}>
        <GameFrame game={game}/>
    </HeaderPage>
}
